import { Box, BoxProps } from '@chakra-ui/react/box';

export type PageContentProps = Omit<BoxProps, 'width'> & {
  width?: string;
};

const PageContent = ({ backgroundColor, width = '848px', ...rest }: PageContentProps) => {
  return (
    <Box backgroundColor={backgroundColor}>
      <Box
        display="flex"
        width={['100%', width]}
        overflow="hidden"
        flexDirection="column"
        flexGrow="1"
        gap="32"
        paddingX={['16', '32']}
        paddingY="48"
        marginX="auto"
        wordBreak="break-word"
        {...rest}
      />
    </Box>
  );
};

export default PageContent;
